import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createUser } from "../../api/users";

export const useCreateUser = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createUser,
    onSuccess: () => {
        // Optionally, you can trigger a refetch of users or show a success message
        queryClient.invalidateQueries({ queryKey: ["users"] });
        console.log("User created successfully");
    },
    onError: (error) => {
        console.error("Error creating user:", error);
    },
  });
};

export default useCreateUser;